import * as React from "react";

import { CustomScrollbar } from "../../../components";
import { ChoiceModal } from "../../../components";

import "./ColorPicker.css";

export interface ColorPickerProps {
  show: boolean;
  customPicker: React.ReactChild;
  children: React.ReactChild | React.ReactChild[];
  onCancel: (event: React.SyntheticEvent<any>) => void;
  onConfirm: (event: React.SyntheticEvent<any>) => void;
}

const ColorPicker = (props: ColorPickerProps) => (
  <ChoiceModal
    isOpen={props.show}
    bodyClassName="color-picker"
    onCancel={props.onCancel}
    onConfirm={props.onConfirm}
  >
    <div className="color-picker__container">
      <p className="color-picker__title hidden-xs">
        Một số bộ phối màu phổ biến
      </p>
      <CustomScrollbar maxHeight={250}>
        <div className="color-picker__scroll">
          <ul className="color-picker__list">{props.children}</ul>
        </div>
      </CustomScrollbar>
      {props.customPicker}
    </div>
  </ChoiceModal>
);

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/routes/WizardColorChoice/components/ColorPicker.tsx